
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UpgradeEligibilityResource,
} from '../models';
import {
    UpgradeEligibilityResourceFromJSON,
    UpgradeEligibilityResourceToJSON,
} from '../models';

export interface GetUpgradeEligibilityRequest {
    organizationId: string;
}

/**
 * 
 */
export class ClientLegalEntityUpgradeEligibilityApi extends runtime.BaseAPI {

    /**
     * Check if an organization is eligible for a plan upgrade based on legal entity verification status
          */
    async getUpgradeEligibilityRaw(requestParameters: GetUpgradeEligibilityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UpgradeEligibilityResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getUpgradeEligibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UpgradeEligibilityResource>({
            path: `/client-settings/api/organizations/{organizationId}/upgrade-eligibility`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UpgradeEligibilityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Check if an organization is eligible for a plan upgrade based on legal entity verification status
          */
    async getUpgradeEligibility(organizationId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UpgradeEligibilityResource> {
        const response = await this.getUpgradeEligibilityRaw({ organizationId: organizationId }, initOverrides);
        return response._data;
    }

}
